module.exports = __webpack_public_path__ + "img/gry_2.735f8ad0.png";